import CAEGlobalSettings from "../../../../types/CAEGlobalSettings";
import {Page} from "../../../../routing/types";
import {isDonationProduct, isHome, isNewsPage, isPublicationPage} from "../../../page_layouts/pageLayoutsUtils";
import {getHomePageSchema} from "./JsonLdForHomePage";
import {getNewsSchema} from "./JsonLdForNews";
import {getProductSchema} from "./JsonLdForProduct";
import {getPublicationSchema} from "./JsonLdForPublications";
import {getFaqSchema} from "./JsonLdForFaq";

export type SchemaProps = {
    page: Page,
    caeGlobalSettings: CAEGlobalSettings,
    currentURL: string,
    pageSettings?: any
};

export function getJsonLdSchema(props: SchemaProps) {
    if (props.pageSettings?.isFAQPage) {
        return getFaqSchema(props);
    } else {
        switch (true) {
            case isNewsPage(props.page):
                return getNewsSchema(props);
            case isPublicationPage(props.page):
                return getPublicationSchema(props);
            case isDonationProduct(props.page):
                return getProductSchema(props);
            case isHome(props.page?.selfUrl):
                return getHomePageSchema(props);
        }
        return null;
    }
}

export default getJsonLdSchema
